var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-control-container"},[_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('camera-control-video',{ref:"cameraControl"})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }